import React, { useEffect, useState } from 'react'
import './styles.css'
import {
	Menu,
	Space,
	Dropdown,
	Button,
	Radio,
} from "antd";
import { DownOutlined } from "@ant-design/icons";

export const ProfessionFilter = ({ setFilterError, setProfessionSelected,
	ClearAll, setProfessionDropdownOpen, professionDropdownOpen,
	searchFilters, professionSelected, windowDimensions, counts, gqlError
}) => {

	const [visible, setVisible] = useState(false)
	const [allProfession,setAllProfession] = useState(0)


	useEffect(() => {
		if (professionDropdownOpen) {
			setVisible(true)
		}
		else {
			setVisible(false)
		}
	}, [professionDropdownOpen])

	const countHC = (obj) => {
		let count = obj?.find(obj => obj.hasOwnProperty('HC'));
		return count
	 };

	 const countIT = (obj) => {
		let count = obj?.find(obj => obj.hasOwnProperty('IT'));
		return count
	 };

	const hcCount = countHC(counts?.professionCodeCounts);
	const itCount = countIT(counts?.professionCodeCounts);


	useEffect(()=>{
		if(hcCount?.HC && itCount?.IT){
			
			let hc = parseInt(hcCount?.HC)
			let it = parseInt(itCount?.IT)
			setAllProfession(hc+it)
		} else if(hcCount?.HC){
			
			setAllProfession(hcCount?.HC)
		} else if (itCount?.IT){
			
			setAllProfession(itCount?.IT)
		}
	},[hcCount, itCount])


	const professionMenu = (
		<Menu>
			<div style={{ width: "90%", margin: "auto" }}>
				<Radio.Group
					value={professionSelected}
					onChange={(e) => {
						setProfessionSelected(e.target.value)
						setFilterError("");
					}}
				>
					<Space direction="vertical" style={{width:'100%', padding:'1%'}}>
					<Radio value={"All"}>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									// columnGap: "85px",
								}}
							>
								<div>All</div>
								{/* {
									allProfession ? (
										<div style={{ color: "#7e7e7e" }}>
											(
											{allProfession}
											)
										</div>
									) : (
										<div style={{ color: "#7e7e7e" }}>(0)</div>
									)
								} */}
							</div>
						</Radio>
						<Radio value={"HC"}>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									// columnGap: "85px",
								}}
							>
								<div>HC - Healthcare</div>
								{/* {
									counts?.professionCodeCounts.filter(obj => obj.hasOwnProperty('HC'))?.length ? (
										<div style={{ color: "#7e7e7e" }}>
											(
											{hcCount?.HC}
											)
										</div>
									) : (
										<div style={{ color: "#7e7e7e" }}>(0)</div>
									)
								} */}
							</div>
						</Radio>
						<Radio value={"IT"}>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>IT - Information Technology</div>{" "}
								{/* { 
									counts?.professionCodeCounts.filter(obj => obj.hasOwnProperty('IT')).length ? (
										<div style={{ color: "#7e7e7e" }}>
											({itCount?.IT})
										</div>
									) : (
										<div style={{ color: "#7e7e7e" }}>(0)</div>
									)
								} */}
							</div>
						</Radio>
					</Space>
				</Radio.Group>
			</div>
			<div style={{ padding: "0px 3% 0px 3%" }}>
				<ClearAll type={"profession"} />
			</div>
		</Menu>
	);

	return (
		<>
			{
				windowDimensions?.width > 768 ?
					<Dropdown
						destroyPopupOnHide={true}
						overlayClassName="professionFilterDropdown"
						overlay={professionMenu}
						trigger="click"
						className={
							searchFilters?.ProfessionCode && "dropdown-job"
						}
						visible={visible}
						onOpenChange={(e) => {
							setProfessionDropdownOpen(!visible);
							setFilterError("");
						}}
					>
						<Button className="profession-dropdown">
							Profession <DownOutlined />
						</Button>
					</Dropdown> :
					<>
						<strong>Profession</strong>
						<Radio.Group onChange={(e) => {
							setProfessionSelected(e.target.value)
							setFilterError("");
						}} style={{ marginBottom: '5%', width: '100%' }} value={professionSelected}>
							<Space direction="vertical" style={{ width: '100%' }}>
								<div className="radios" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }} >
									<Radio value={"HC"}>
										HC - Healthcare
									</Radio>
								</div>
								<div className="radios" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>
									<Radio value={"IT"}>
										IT - Information Technology
									</Radio>
								</div>
							</Space>
						</Radio.Group>
					</>
			}
		</>
	)
}